/**
 * Wrapper around the EventEmitter to only allow public only events to be registered
 * @module
 */
var EventEmitter = require('./index');

/**
 * Adds an event listener
 * @param {Object} options
 * @param {Function} options.handler
 * @param {Object} [options.filter] filter only certain event type/names from being handled
 * @param {string} [options.filter.type]
 * @param {string} [options.filter.name]
 * @param {Token} [options.token] unique identifier that can be used to unlisten to event
 * @param {boolean} [options.publicOnly]
 * @return {string} token
 */
exports.on = function(options:any): string {
  options.publicOnly = true;
  return EventEmitter.on(options);
};

/**
 * Removes an event handler by token
 * @param {string} token
 */
exports.off = EventEmitter.off;

/**
 * Expose emit event that doesn't allow the isInternal second parameter
 * @param {EmitterEvent} event
 */
exports.emit = function(event:EmitterEvent) {
  EventEmitter.emit(event);
};
